export function calculateCapacity(demandConfig, parts, machines) {
  const { wosMin, wosMax, qtyMin, qtyMax, horizonDays,
          partDistributionMode, partWeights = {} } = demandConfig;

  const avgWos      = (wosMin + wosMax) / 2;
  const avgQty      = (qtyMin + qtyMax) / 2;
  const partsPerDay = (avgWos / horizonDays) * avgQty;

  const totalWeight = partDistributionMode === 'weighted' && Object.keys(partWeights).length > 0
    ? Object.values(partWeights).reduce((s, w) => s + w, 0)
    : parts.length;
  const weight = (partId) =>
    partDistributionMode === 'weighted' && partWeights[partId] != null
      ? partWeights[partId] / totalWeight
      : 1 / parts.length;

  const machinesByType = {};
  for (const m of machines) {
    if (!m.machineType) continue;
    machinesByType[m.machineType] = (machinesByType[m.machineType] || 0) + 1;
  }

  return Object.entries(machinesByType).map(([type, count]) => {
    const partsWithType = parts.filter(p =>
      p.operations?.some(o => o.machineType === type)
    );

    let totalW = 0, weightedCycle = 0;
    for (const p of partsWithType) {
      const op = p.operations.find(o => o.machineType === type);
      const w  = weight(p.id);
      weightedCycle += (op?.cycleTime ?? 0) * w;
      totalW        += w;
    }
    const avgCycleTime = totalW > 0 ? weightedCycle / totalW : 0;

    const distributionShare     = partsWithType.reduce((s, p) => s + weight(p.id), 0);
    const demandSecondsPerDay   = partsPerDay * distributionShare * avgCycleTime;
    const capacitySecondsPerDay = count * 86400;
    const utilizationPct = capacitySecondsPerDay > 0
      ? Math.min(Math.round((demandSecondsPerDay / capacitySecondsPerDay) * 100), 999)
      : 0;

    let status     = 'balanced';
    let suggestion = null;
    if (utilizationPct > 90) {
      status = 'bottleneck';
      const needed = Math.ceil(demandSecondsPerDay / 86400);
      const newPct = Math.round((demandSecondsPerDay / (needed * 86400)) * 100);
      suggestion = `Add ${needed - count} ${type.replace(/_/g, ' ')} → drops to ${newPct}%`;
    } else if (utilizationPct < 50 && count > 1) {
      status = 'surplus';
      suggestion = `${type.replace(/_/g, ' ')} has excess capacity — consider fewer machines or more demand`;
    }

    return { type, machineCount: count, utilizationPct, status, suggestion };
  });
}
